
import Echo from 'laravel-echo';
import Pusher from 'pusher-js';
import { environment } from "../../environments/environment";

let echoInstance: Echo<any> | null = null;
window.Pusher = Pusher;

// console.log("log laravel-echo.ts!!")

// export const echo = new Echo({
//   authEndpoint: environment.MIX_PUSHER_BACKEND_API + '/broadcasting/auth',
//   broadcaster: 'pusher',
//   key: environment.MIX_PUSHER_APP_KEY,
//   wsHost: environment.MIX_PUSHER_HOST,
//   wsPort: environment.MIX_PUSHER_PORT,
//   wssPort: environment.MIX_PUSHER_PORT,
//   forceTLS: environment.MIX_PUSHER_TLS,
//   encrypted: true,
//   disableStats: true,
//   enabledTransports: ['ws', 'wss'],
//   cluster: environment.MIX_PUSHER_APP_CLUSTER,
// });

export const initializeEcho = (token: string, MIX_PUSHER_APP_KEY, MIX_PUSHER_HOST, pusherApiUrl) => {
  if (!echoInstance) {
    echoInstance = new Echo({
      authEndpoint: pusherApiUrl + 'broadcasting/auth',
      broadcaster: 'pusher',
      key: MIX_PUSHER_APP_KEY,
      wsHost: MIX_PUSHER_HOST,
      wsPort: environment.MIX_PUSHER_PORT,
      wssPort: environment.MIX_PUSHER_PORT,
      forceTLS: environment.MIX_PUSHER_TLS,
      encrypted: true,
      disableStats: true,
      enabledTransports: ['ws', 'wss'],
      cluster: environment.MIX_PUSHER_APP_CLUSTER,
      auth: {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    });
  }
  return echoInstance;
};

export const getEcho = () => {
  if (!echoInstance) {
    console.log('Echo no ha sido inicializado.')
  }
  return echoInstance;
};





















// const echo = new Echo({
//     authEndpoint: environment.VITE_BACKEND_API + '/broadcasting/auth',
//     broadcaster: 'pusher',
//     key: environment.MIX_PUSHER_APP_KEY,
//     wsHost: environment.MIX_PUSHER_HOST,
//     wsPort: environment.MIX_PUSHER_PORT,
//     wssPort: environment.MIX_PUSHER_PORT,
//     forceTLS: environment.MIX_PUSHER_TLS,
//     encrypted: true,
//     disableStats: true,
//     enabledTransports: ['ws', 'wss'],
//     cluster: environment.MIX_PUSHER_APP_CLUSTER,

//     auth: {
//         headers: {
//             Authorization: 'Bearer ' + token,
//             // 'Content-Type': 'application/json',
//         }
//     }
// });

// export { echo }
